import { FormLayout } from 'modules/campaigns/components';
import { useFormDataContext, withFormDataProvider } from 'modules/taboola-common-frontend-modules/formData';
import { FormInitBase } from 'modules/taboola-common-frontend-modules/forms/components';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { useUnsavedChangesController } from 'modules/taboola-common-frontend-modules/navigation/hooks/useUnsavedChangesController';
import { SubscriptionInitializeSection } from '../components/SubscriptionInitializeSection/SubscriptionInitializeSection';
import { SubscriptionOutputSection } from '../components/SubscriptionOutputSection/SubscriptionOutputSection';
import { SubscriptionSetupSection } from '../components/SubscriptionSetupSection/SubscriptionSetupSection';
import { PUSH_API_EDIT_ROUTE_PATH } from '../config';
import { usePushApiEditorState } from '../hooks/usePushApiEditorState';
import styles from './pushApiEditorPage.module.scss';

const PushApiEditorPage = ({ onCancel }) => {
    const { submit } = usePushApiEditorState();
    const { isSubmitDisabled, submitInProgress, mode } = useFormDataContext();
    useUnsavedChangesController(PUSH_API_EDIT_ROUTE_PATH);

    return (
        <FormInitBase className={styles['wrapper']}>
            <FormLayout
                onCancel={onCancel}
                onSubmit={submit}
                header={
                    <div className={styles['header']}>
                        <FormattedMessage id="push-api.editor.header" defaultMessage="Edit Subscription" tagName="h1" />
                    </div>
                }
                submitButtonText={<FormattedMessage id={`app.actionButtons.${mode}.save`} defaultMessage="Save" />}
                contentContainerClassName={styles['editor']}
                bodyContainerClassName={styles['editor-body']}
                footerContainerClassName={styles['editor-footer']}
                submitInProgress={submitInProgress}
                disableSubmit={isSubmitDisabled}
            >
                <div className={styles['content']}>
                    <SubscriptionInitializeSection />
                    <SubscriptionSetupSection />
                    <SubscriptionOutputSection />
                </div>
            </FormLayout>
        </FormInitBase>
    );
};

const PushApiEditorWithFormDataProvider = withFormDataProvider(PushApiEditorPage, {
    formContainerId: FormLayout.BODY_CONTAINER_ID,
    isNetworkOwnerAllowed: true,
});

export { PushApiEditorWithFormDataProvider as PushApiEditorPage };
